import React from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import PropTypes from 'prop-types';
import CustomInput from './CustomInput';

const PhoneNumberWithCountrySelectInput = ({
  value,
  placeholder,
  onChange,
  countryCallingCodeEditable,
  isRequired,
  disabled,
  defaultCountry,
}) => (
  <PhoneInput
    className="PhoneInput sm:px-6 sm:py-3 px-4 py-2 h-auto w-full rounded-2xl border border-gray-500 border-opacity-25 bg-gray-500 bg-opacity-5 placeholder-gray-700 focus:outline-none"
    style={{ padding: '0px 0px 0px 10px' }}
    initialValueFormat="national"
    countryCallingCodeEditable={countryCallingCodeEditable}
    placeholder={`${placeholder} ${isRequired ? '(Required)' : '(Optional)'}`}
    value={value}
    defaultCountry={defaultCountry}
    onChange={onChange}
    disabled={disabled}
    inputComponent={CustomInput}
    addInternationalOption={false}
    limitMaxLength
  />
);

PhoneNumberWithCountrySelectInput.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  countryCallingCodeEditable: PropTypes.bool,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultCountry: PropTypes.string,
};

PhoneNumberWithCountrySelectInput.defaultProps = {
  placeholder: 'Enter a Phone Number',
  countryCallingCodeEditable: true,
  isRequired: true,
  disabled: false,
  defaultCountry: 'US',
};

export default PhoneNumberWithCountrySelectInput;
